class SidebarFilter {
  paged = 1;
  filtersArray = [];
  orderBy = "sales";

  constructor() {
    this.paged = this.getPageFromUrl(window.location.href);
    this.accordionInit();
    this.priceSlider();
    this.filters();
    this.responsiveFilter();
    this.handleButtonClick();
    this.pagination();
    this.sortInit();
  }

  getPageFromUrl = (url) => {
    const parsedUrl = new URL(url, window.location.origin);
    const pathPage = parsedUrl.pathname.match(/\/page\/(\d+)\/?$/);
    const page = Number(parsedUrl.searchParams.get("paged") || pathPage?.[1]);

    return Number.isInteger(page) && page > 0 ? page : 1;
  };

  responsiveFilter = () => {
    const btn = document.querySelector(".js-filter-responsive-btn");
    const wrapper = document.querySelector(".js-filter-responsive");
    const exit = document.querySelector(".js-filter-responsive-exit");
    if (!btn || !wrapper || !exit) {
      return;
    }
    btn.addEventListener("click", () => {
      wrapper.classList.add("active");
    });
    exit.addEventListener("click", () => {
      wrapper.classList.remove("active");
    });
  };

  accordionInit = () => {
    const btn = document.querySelector(".js-sidebar-filter-btn");
    const content = document.querySelector(".js-sidebar-filter-content");
    if (!btn || !content) {
      return;
    }
    btn.addEventListener("click", () => {
      content.classList.toggle("active");
      btn.classList.toggle("active");
    });
  };
  filters = () => {
    const items = document.querySelectorAll(".js-sidebar-filter-item");
    if (items.length == 0) {
      return;
    }
    items.forEach((item) => {
      item.addEventListener("click", () => {
        item.classList.toggle("active");
        let tax = item.getAttribute("data-tax");
        let slug = item.getAttribute("data-slug");
        let remove = false;
        if (!item.classList.contains("active")) {
          remove = true;
        }
        this.paged = 1;
        this.applyFilters({ taxonomy: tax, slug: slug }, remove);
      });
    });
  };
  resetFilters = () => {
    const items = document.querySelectorAll(".js-sidebar-filter-item");
    const values = document.querySelectorAll(".js-filter-value");
    const ranges = document.querySelectorAll(".js-range-input");
    items.forEach((item) => {
      item.classList.remove("active");
    });
    values.forEach((value, index) => {
      value.innerText = value.getAttribute("data-price");
      ranges[index].value = value.getAttribute("data-price");
    });
    this.priceSlider();
  };

  applyFilters = (filter, remove) => {
    if (!remove) {
      this.filtersArray.push(filter);
    } else {
      this.filtersArray = this.filtersArray.filter((item) => {
        return item.taxonomy != filter.taxonomy || item.slug != filter.slug;
      });
    }
  };

  handleButtonClick = () => {
    const btns = document.querySelectorAll(".js-product-filter-btn");
    btns.forEach((btn) => {
      btn.addEventListener("click", () => {
        this.paged = 1;
        if (btn.classList.contains("reset")) {
          this.resetFilters();
          this.filtersArray = [];
          this.fetchData(
            "product_filter",
            btn.getAttribute("data-active-term")
          );
        } else {
          this.fetchData(
            "product_filter",
            btn.getAttribute("data-active-term")
          );
        }
      });
    });
  };

  pagination = () => {
    const wrapper = document.querySelector(".js-product-col-wrapper");
    const sort = document.querySelector(".js-sort-dropdown-current");
    if (!wrapper || !sort) {
      return;
    }
    wrapper.addEventListener("click", (event) => {
      const link = event.target.closest("a.page-numbers");
      if (!link || !wrapper.contains(link)) {
        return;
      }
      event.preventDefault();
      this.paged = this.getPageFromUrl(link.href);
      this.fetchData("product_filter", sort.getAttribute("data-active-term"));
    });
  };

  sortInit = () => {
    const btn = document.querySelector(".js-sort-dropdown-current");
    const dropdown = document.querySelector(".js-sort-dropdown");
    const items = document.querySelectorAll(".js-sort-item");
    if (!btn) {
      return;
    }
    btn.addEventListener("click", () => {
      dropdown.classList.toggle("active");
      btn.classList.toggle("active");
    });
    items.forEach((item) => {
      item.addEventListener("click", () => {
        dropdown.classList.remove("active");
        btn.classList.remove("active");
        let current = btn.querySelector("span");
        let temp = current.innerText;
        current.innerText = item.innerText;
        item.innerText = temp;
        let tempData = btn.getAttribute("data-sort");
        btn.setAttribute("data-sort", item.getAttribute("data-sort"));
        item.setAttribute("data-sort", tempData);
        this.orderBy = btn.getAttribute("data-sort");
        this.paged = 1;
        this.fetchData("product_filter", btn.getAttribute("data-active-term"));
      });
    });
  };

  fetchData = async (action, activeTerm) => {
    const wrapper = document.querySelector(".js-product-col-wrapper");
    const spinner = document.querySelector(".js-spinner");
    const minValue = document.querySelector(".js-filter-minvalue").innerText;
    const maxValue = document.querySelector(".js-filter-maxvalue").innerText;
    let formData = new FormData();
    formData.append("action", action);
    formData.append("page", this.paged);
    formData.append("active_term", activeTerm);
    formData.append("sort", this.orderBy);
    formData.append("filters", JSON.stringify(this.filtersArray));
    formData.append("min_value", minValue);
    formData.append("max_value", maxValue);
    spinner.classList.add("active");
    const response = await fetch(ajaxurl, {
      method: "POST",
      body: formData,
    });
    const data = await response.json();
    wrapper.innerHTML = data.files;
    spinner.classList.remove("active");
  };

  priceSlider = () => {
    const minRangeValueGap = 6;
    const range = document.querySelector(".js-range-track");
    const minval = document.querySelector(".minvalue");
    const maxval = document.querySelector(".maxvalue");
    const rangeInput = document.querySelectorAll(".js-range-input");

    let minRange, maxRange;
    const sliderMin = parseInt(rangeInput[0].min || "0", 10);
    const sliderMax = parseInt(rangeInput[0].max, 10);
    const sliderSpan = sliderMax - sliderMin;

    const setMinValueOutput = () => {
      minRange = rangeInput[0].valueAsNumber;
      minval.textContent = minRange;
    };

    const setMaxValueOutput = () => {
      maxRange = rangeInput[1].valueAsNumber;
      maxval.textContent = maxRange;
    };

    const updateTrack = () => {
      const minPercent = ((minRange - sliderMin) / sliderSpan) * 100;
      const maxPercent = ((maxRange - sliderMin) / sliderSpan) * 100;

      // Option A: left + right (your original approach)
      range.style.left = minPercent + "%";
      range.style.right = 100 - maxPercent + "%";

      // Option B (often easier): left + width
      // range.style.left = minPercent + "%";
      // range.style.width = (maxPercent - minPercent) + "%";
    };

    // Initial setup
    setMinValueOutput();
    setMaxValueOutput();
    updateTrack();

    rangeInput.forEach((input) => {
      input.addEventListener("input", (e) => {
        setMinValueOutput();
        setMaxValueOutput();

        // Enforce minimum gap
        if (maxRange - minRange < minRangeValueGap) {
          if (e.target === rangeInput[0]) {
            rangeInput[0].value = maxRange - minRangeValueGap;
            setMinValueOutput();
          } else {
            rangeInput[1].value = minRange + minRangeValueGap;
            setMaxValueOutput();
          }
        }

        updateTrack();
      });
    });
  };
}

export default SidebarFilter;
